<template>
  <DialogTemplate
    :show-controls="showControls"
    :close-click-outside="closeClickOutside"
    class="dialog-avatars"
  >
    <template #header><h4>Choix de l'avatar</h4></template>
    <div class="avatars-wrapper">
      <div class="groups">
        <DialogAvatarsGroup
          v-for="[key, value] in mediaGroups"
          :key="key"
          v-model="selectedMedia"
          :name="value.name"
          :list="value.list"
        />
      </div>
    </div>
    <ButtonBase
      class="button-submit"
      stroke="n"
      size="small"
      theme="secondary"
      rounded
      :disabled="!selectedMedia"
      @click="emit('confirm', selectedMedia)"
    >
      Sélectionner
    </ButtonBase>
  </DialogTemplate>
</template>
<script lang="ts" setup>
import { getServices } from '~/db/services';

interface Props {
  showControls?: boolean;
  closeClickOutside?: boolean;
}
defineProps({
  showControls: { type: Boolean, default: true },
  closeClickOutside: { type: Boolean, default: true }
});
const config = useConfigStore();
const mediaList: Ref<MediaSchema[]> = ref([]);

const { $db } = useNuxtApp();
const { mediasService } = getServices($db);

const selectedMedia = ref('');
const mediaGroups = computed(() => {
  const groups = new Map<string, { name: string; list: MediaSchema[] }>();

  mediaList.value.forEach((media) => {
    if (!groups.has(media.groupName)) {
      groups.set(media.groupName, {
        name: media.groupName,
        list: [],
      });
    }
    groups.get(media.groupName).list.push(media);
  });
  return groups;
});
const emit = defineEmits(["cancel", "confirm"]);

mediaList.value = await mediasService.findByIdsAndLibraryBookId(
  config.avatarIds,
  ''
);
</script>
<style lang="scss" scoped>
.avatars-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 40vh;
  max-height: 40dvh;
  padding: 0;
  gap: 1rem;
  @include above('m') {
    max-width: 60rem;
  }
}
.groups {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
  padding: 0 2rem 0 0;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0.5rem;
  }
  &::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-track {
    border-radius: 0.25rem;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--color_neutral_500);
  }

  &::-webkit-scrollbar-track {
    background: var(--color_neutral_100);
  }
}
</style>
